import { render, staticRenderFns } from "./postdoctorResearch.vue?vue&type=template&id=505b4661&scoped=true&"
import script from "./postdoctorResearch.vue?vue&type=script&lang=js&"
export * from "./postdoctorResearch.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorResearch.vue?vue&type=style&index=0&id=505b4661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b4661",
  null
  
)

export default component.exports